import { defineMessages } from "react-intl";

export const messages = defineMessages({
    fastshiftAssistanceSectionTitle: {
        id: "fastshift.assistance.section.title",
        defaultMessage: "FastShift Assistance",
        description: "Title for the FastShift assistance section"
    },
    fastshiftAssistanceCardTitle: {
        id: "fastshift.assistance.card.title",
        defaultMessage: "Message your FastShift team",
        description: "Title for the FastShift assistance card"
    },
    fastshiftAssistanceCardDescription: {
        id: "fastshift.assistance.card.description",
        defaultMessage:
            "Get guidance or support directly from your FastShift team.",
        description: "Description for the FastShift assistance card"
    },
    fastshiftAssistanceCardButton: {
        id: "fastshift.assistance.card.button",
        defaultMessage: "Request FastShift Assistance",
        description: "Button text for requesting FastShift assistance"
    }
});
